var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#04B7B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5597_119606",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5597_119606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 17C17.1667 17 16.4583 16.7083 15.875 16.125C15.2917 15.5417 15 14.8333 15 14C15 13.1667 15.2917 12.4583 15.875 11.875C16.4583 11.2917 17.1667 11 18 11C18.8333 11 19.5417 11.2917 20.125 11.875C20.7083 12.4583 21 13.1667 21 14C21 14.8333 20.7083 15.5417 20.125 16.125C19.5417 16.7083 18.8333 17 18 17ZM11 20C10.45 20 9.97933 19.804 9.588 19.412C9.196 19.0207 9 18.55 9 18V10C9 9.45 9.196 8.97933 9.588 8.588C9.97933 8.196 10.45 8 11 8H25C25.55 8 26.021 8.196 26.413 8.588C26.8043 8.97933 27 9.45 27 10V18C27 18.55 26.8043 19.0207 26.413 19.412C26.021 19.804 25.55 20 25 20H11ZM13 18H23C23 17.45 23.1957 16.979 23.587 16.587C23.979 16.1957 24.45 16 25 16V12C24.45 12 23.979 11.804 23.587 11.412C23.1957 11.0207 23 10.55 23 10H13C13 10.55 12.804 11.0207 12.412 11.412C12.0207 11.804 11.55 12 11 12V16C11.55 16 12.0207 16.1957 12.412 16.587C12.804 16.979 13 17.45 13 18ZM24 24H7C6.45 24 5.97933 23.8043 5.588 23.413C5.196 23.021 5 22.55 5 22V11H7V22H24V24Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/Payments.461386c6fc3edcfd86f4f9f0834f5bcc.svg";
export { ForwardRef as ReactComponent };